module.exports = __webpack_public_path__ + "static/media/Webshopper-Premium-42.4ee37b6a.4ee37b6a.JPG";